import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Checkbox, Input, Select, Textarea } from "../../../ui/inputs/Input";
import { formatMoneda, validaSoloNumero } from "../../../util/varios";
import { Dimmer } from "../../spinner";
import axios from "axios";
import moment from "moment";
import { Mensaje } from "../../mensajes2";
import {
  DangerButton,
  PrimaryButton,
  SuccessButton,
} from "../../../ui/buttons/Button";
import TablaDeudasVehiculos from "./tablaDeudasVehiculos2";
import TablaMultaVehiculos from "./tablaMultaVehiculos2";
import TablaPagosVehiculos from "./tablaPagosVehiculos2";
export const AgregarVehiculos = (props) => {
  const token = localStorage.getItem("jwtToken");
  const idUsuario = localStorage.getItem("idusuario");
  const ip = localStorage.getItem("ip");
  const mac = localStorage.getItem("mac");
  const op = require("../../../modulos/datos");
  const fecha = new Date();
  const anioActual = fecha.getFullYear();
  const anios = Array.from(new Array(7), (val, index) => anioActual - index);
  const fechaSistema = localStorage.getItem("fechasistema");
  const fechaActual = moment().format("YYYY-MM-DD");
  const [operacion, setOperacion] = useState(4);
  const factorCambio = JSON.parse(localStorage.getItem('factorCambio'))
  const [loading, setLoading] = useState(false);
  const [loadingBita, setLoadingBita] = useState(false);
  const [loadingDeclaWeb, setLoadingDeclaWeb] = useState(false);
  const [declaweb, setDeclaweb] = useState(false);
  const [refreshDeuda, setRefreshDeuda] = useState(false);
  const [clasesVehiculo, setClasesVehiculo] = useState([]);
  const [montoAnual, setMontoAnual] = useState("");
  const [montoAnualBs, setMontoAnualBs] = useState(0)
  const [anio, setAnio] = useState(anioActual);
  const [cargdeuda, setCargadeuda] = useState({
    periodo: 0,
    periodopago: 0,
    periodohasta: 0,
  });
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
    hideModal: false,
  });
  const [values, setValues] = useState({
    idvehiculo: "",
    nombrepropie: "",
    cedulapropie: "",
    direccionpropie: "",
    ritm: "",
    telefonopropie: "",
    nombrerespo: "",
    cedularespo: "",
    direccionrespo: "",
    telefonorespo: "",
    serialcarroceria: "",
    serialmotor: "",
    placa: "",
    marca: "",
    modelo: "",
    anio: "",
    color: "",
    uso: "",
    numpuesto: "",
    peso: "0,0",
    capacidadcarga: "0,0",
    servicio: "",
    tipovehiculo: "",
    valorvehiculo: "0,0",
    idclasevehiculo: "",
    fechainscripcion: fechaActual,
    status: "0",
  });
  const buscarVehiculoId = async (idVehiculo) => {
    try {
      setLoading(true);
      const campos = "*";
      const nomtab = "vehiculo";
      const nomid = "idvehiculo";
      const endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${idVehiculo}&nomtab=${nomtab}&nomid=${nomid}`;
      const response = await axios.get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      });
      if (response.status === 200 && response.data) {
        setValues((prev) => ({
          ...prev,
          ...response.data,
        }));
      }
    } catch (error) {
      setMensaje({
        mostrar: true,
        titulo: "ERROR",
        texto: "Error al Buscar los Registros del Vehiculo Seleccionado",
        icono: "error",
      });
    } finally {
      setLoading(false);
    }
  };
  const actualizarVehiculo = async () => {
    try {
      setLoading(true);
      const endpoint = `${op.conexion}/api/vehiculo/createvehiculos/${operacion}`;
      const response = await axios.post(
        endpoint,
        {
          ...values,
          idvehiculo: parseInt(values.idvehiculo),
          peso: values.peso.trim().replace(/\./g, "").replace(",", "."),
          anio: parseInt(values.anio),
          numpuesto: parseInt(values.numpuesto),
          status: parseInt(values.status),
          capacidadcarga: values.capacidadcarga
            .trim()
            .replace(/\./g, "")
            .replace(",", "."),
          valorvehiculo: values.valorvehiculo
            .trim()
            .replace(/\./g, "")
            .replace(",", "."),
        },
        {
          headers: {
            "x-access-token": `${token}`,
            "Content-Type": "application/json",
          },
        },
      );
      if (response.status === 200 && response.data) {
        const { vehiculo_act } = response.data;
        const tipoOpe =
          operacion === 1 ? "INCLUIR" : operacion === 2 ? "EDITAR" : "ELIMINAR";
        const mensaje =
          operacion === 1
            ? "Incluido"
            : operacion === 2
              ? "Modificado"
              : "Eliminado";
        registrarBitacora(tipoOpe, "vehiculo", vehiculo_act);
        if (declaweb) {
          crearMovimientoweb(operacion, "vehiculo", vehiculo_act);
        }
        setMensaje({
          mostrar: true,
          titulo: "Exito",
          texto: `Registro ${mensaje} Correctamente`,
          icono: "exito",
          hideModal: true,
        });
      }
    } catch (error) {
      setMensaje({
        mostrar: true,
        titulo: "ERROR",
        texto: "Error al Registrar el  Vehiculo",
        icono: "error",
      });
    } finally {
      setLoading(false);
    }
  };
  const buscarClasesVehiculos = async () => {
    try {
      setLoading(true);
      const endpoint = `${op.conexion}/api/catalogo/clasevehiculos`;
      const response = await axios.get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      });
      if (
        response.status === 200 &&
        response.data &&
        response.data.length > 0
      ) {
        setClasesVehiculo(response.data);
      }
    } catch (error) {
      setMensaje({
        mostrar: true,
        titulo: "ERROR",
        texto: "Error al Buscar las Clases de los Vehiculo",
        icono: "error",
      });
    } finally {
      setLoading(false);
    }
  };
  const crearDeuda = async () => {
    try {
      setLoading(true);
      const endpoint = `${op.conexion}/api/vehiculo/createdeudavehiculos/1`;
      const body = {
        idvehiculo: parseInt(values.idvehiculo),
        nomtab: "deudavehiculo",
        nomid: "idvehiculo",
        peri: parseInt(cargdeuda.periodo),
        monto: parseFloat(montoAnual),
        nanio: parseInt(anio),
        mesdesde: parseInt(1),
        meshasta: parseInt(cargdeuda.periodohasta),
        nomiddeu: "iddeudavehiculo",
        tipo: parseInt(0),
      };
      const response = await axios.post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      });
      if (response.status === 200) {
        registrarBitacora("CREAR DEUDA", "deudavehiculo", values.idvehiculo);
        if (declaweb) {
          crearMovimientoweb(1, "deudavehiculo", values.idvehiculo);
        }
        setMensaje({
          mostrar: true,
          titulo: "",
          texto: `Al Registro: ${values.idvehiculo} le fue Cargada la Deuda para el Año ${anio}`,
          icono: "exito",
          hideModal: false,
        });
      }
    } catch (error) {
      setMensaje({
        mostrar: true,
        titulo: "ERROR",
        texto:
          error.response && error.response.data
            ? error.response.data.message
            : "Error al Crear la Deuda del Vehiculo",
        icono: "error",
      });
    } finally {
      setLoading(false);
      setRefreshDeuda(true);
    }
  };
  const buscarConfigValorVehiculo = async () => {
    try {
      setLoading(true);
      const endpoint = `${op.conexion}/api/vehiculo/configvehiculo`;
      const response = await axios.get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      });
      if (response.status === 200 && response.data) {
        const { factorcalculo } = response.data;
        switch (factorcalculo) {
          case 1:
            setCargadeuda({ periodo: 1, periodopago: 1, periodohasta: 1 });
            break;
          case 2:
            setCargadeuda({ periodo: 4, periodopago: 3, periodohasta: 12 });
            break;
          case 3:
            setCargadeuda({
              periodo: 12,
              periodopago: 1,
              periodohasta: 12,
            });
            break;
        }
      }
    } catch (error) {
      setMensaje({
        mostrar: true,
        titulo: "ERROR",
        texto: "Error al Buscar la Configuracion del Valor del Vehiculo",
        icono: "error",
      });
    } finally {
      setLoading(false);
    }
  };
  const registrarBitacora = async (tipoope, nomtab, idtab) => {
    try {
      setLoadingBita(true);
      const endpoint = `${op.conexion}/api/comun/crearbitacora`;
      const body = {
        tipope: tipoope,
        nomtabla: nomtab,
        idtab: idtab,
        nanio: parseInt(anio),
        nmesini: 1,
        nmesfin: 12,
        fecpag: null,
        numfac: null,
        monini: 0.0,
        monaju: 0.0,
        moncrea: montoAnual.trim().replace(/\./g, "").replace(",", "."),
        idusu: JSON.parse(idUsuario),
        fecope: fechaSistema,
        fecreal: fechaSistema,
        cdirip: JSON.parse(ip),
        cdirmac: JSON.parse(mac),
      };
      await axios.post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      });
    } catch (error) {
      setMensaje({
        mostrar: true,
        titulo: "ERROR",
        texto: "Error al Registrar Bitacora",
        icono: "error",
      });
    } finally {
      setLoadingBita(false);
    }
  };
  const buscarDeclaWeb = async () => {
    try {
      setLoading(true);
      const endpoint = `${op.conexion}/api/comun/seleccionaregistros?campos=declaracionweb&nomtab=configvehiculo&orden=1`;
      const response = await axios.get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      });
      if (response.status === 200 && response.data) {
        setDeclaweb(response.data[0].declaracionweb);
      }
    } catch (error) {
      setMensaje({
        mostrar: true,
        titulo: "ERROR",
        texto: "Error al Buscar Delcara Web",
        icono: "error",
      });
    } finally {
      setLoading(false);
    }
  };
  const crearMovimientoweb = async (operacion, nomtab, idtab) => {
    try {
      setLoadingDeclaWeb(true);
      const endpoint = `${op.conexion}/api/comun/crearmovimientoweb/${operacion}`;
      const body = {
        idmovi: null,
        nomtabla: nomtab,
        idtab: idtab,
        fecmovi: fechaSistema,
        riff: null,
        idcomer: idtab,
        idact: null,
        nanio: parseInt(anio),
        mess: null,
        tipdecla: null,
        numfac: null,
        prefac: null,
        operaper: null,
        actu: false,
        nmes: null,
        tip: null,
        peri: null,
      };
      await axios.post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      });
    } catch (error) {
      setMensaje({
        mostrar: true,
        titulo: "ERROR",
        texto: "Error al Crear el Movimiento Web",
        icono: "error",
      });
    } finally {
      setLoadingDeclaWeb(false);
    }
  };
  const onChange = (nom, value) => {
    try {
      setValues((prev) => ({
        ...prev,
        [nom]: value,
      }));
    } catch (error) {
      setMensaje({
        mostrar: true,
        titulo: "ERROR",
        texto: "Error al Cambiar el Valor",
        icono: "error",
      });
    }
  };
  const validarResponsable = (isResponsable) => {
    if (isResponsable) {
      setValues({
        ...values,
        cedularespo: values.cedulapropie,
        nombrerespo: values.nombrepropie,
        direccionrespo: values.direccionpropie,
        telefonorespo: values.telefonopropie,
      });
    } else {
      setValues({
        ...values,
        cedularespo: "",
        nombrerespo: "",
        direccionrespo: "",
        telefonorespo: "",
      });
    }
  };
  const handleInputMontoChange = (event) => {
    let value = event.target.value;
    const nom = event.target.name;
    const cursorPosition = event.target.selectionStart;

    if (value === "") {
      event.target.value = "";
      return;
    }

    // Guardar el valor numérico crudo antes de formatear
    let cleanValue = value.replace(/\./g, "");

    let parts = cleanValue.split(",");
    let enteros = parts[0].replace(/\D/g, "");
    let decimales = parts[1] ? parts[1].replace(/\D/g, "") : "";

    // Limitar decimales a 2 caracteres, pero PERMITIR que esté incompleto
    if (decimales.length > 2) {
      decimales = decimales.substring(0, 2);
    }

    // Formatear enteros con puntos de miles
    let enterosFormateados = enteros.replace(/\B(?=(\d{3})+(?!\d))/g, ".");

    // Construir resultado
    let resultado = enteros;

    // Si hay decimales O el usuario escribió la coma, mostrar la coma
    if (decimales.length > 0 || cleanValue.includes(",")) {
      resultado += "," + decimales;
    }

    // Calcular diferencia de longitud para ajustar cursor
    const oldLength = value.length;
    event.target.value = resultado;
    const newLength = resultado.length;

    // Ajustar posición del cursor
    let newCursorPosition = cursorPosition + (newLength - oldLength);

    // Si el cursor estaba después de la coma y ahora la coma cambió de posición
    const comaIndex = resultado.indexOf(",");
    if (cursorPosition > value.indexOf(",") && comaIndex !== -1) {
      newCursorPosition = Math.min(newCursorPosition, resultado.length);
    }

    newCursorPosition = Math.max(
      0,
      Math.min(newCursorPosition, resultado.length),
    );
    event.target.setSelectionRange(newCursorPosition, newCursorPosition);
    setValues((prev) => ({
      ...prev,
      [nom]: resultado,
    }));
  };
  const handleInputNumChange = (event) => {
    validaSoloNumero(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      setValues({ ...values, [event.target.name]: event.target.value });
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false;
  };
  const validarCamposVacios = () => {
    try {
      // Definir campos requeridos con sus nombres amigables
      const camposValidar = [
        { campo: "nombrepropie", nombre: "Nombre del Propietario" },
        { campo: "cedulapropie", nombre: "Cédula del Propietario" },
        { campo: "direccionpropie", nombre: "Dirección del Propietario" },
        { campo: "telefonopropie", nombre: "Número de Contacto" },
        { campo: "cedularespo", nombre: "Cédula del Responsable" },
        { campo: "nombrerespo", nombre: "Nombre del Responsable" },
        { campo: "telefonorespo", nombre: "Número de Contacto" },
        { campo: "direccionrespo", nombre: "Dirección del Responsable" },
        { campo: "placa", nombre: "Placa del vehículo" },
        { campo: "marca", nombre: "Marca" },
        { campo: "modelo", nombre: "Modelo" },
        { campo: "anio", nombre: "Año" },
        { campo: "serialcarroceria", nombre: "Serial de carrocería" },
        { campo: "serialmotor", nombre: "Serial del motor" },
        { campo: "tipovehiculo", nombre: "Tipo de vehículo" },
        { campo: "peso", nombre: "Peso del vehículo" },
        { campo: "capacidadcarga", nombre: "Capacidad de Carga de vehículo" },
        { campo: "numpuesto", nombre: "Número de Puestos" },
        { campo: "valorvehiculo", nombre: "Valor del Vehiculo" },
        { campo: "uso", nombre: "Uso del Vehiculo" },
        { campo: "color", nombre: "Color del Vehiculo" },
        { campo: "fechainscripcion", nombre: "Fecha" },
      ];
      for (let item of camposValidar) {
        if (
          !values[item.campo] ||
          values[item.campo].toString().trim() === ""
        ) {
          setMensaje({
            mostrar: true,
            titulo: "CAMPO REQUERIDO",
            texto: `El campo "${item.nombre}" es obligatorio`,
            icono: "error",
          });
          return;
        }
      }
      actualizarVehiculo();
    } catch (error) {
      setMensaje({
        mostrar: true,
        titulo: "ERROR",
        texto: "Error al Validar los Campos",
        icono: "error",
      });
    }
  };
  const blanquear = () => {
    setMensaje({
      mostrar: false,
      titulo: "",
      texto: "",
      icono: "",
    });
    setAnio(anioActual);
    setValues({
      idvehiculo: "",
      nombrepropie: "",
      cedulapropie: "",
      direccionpropie: "",
      ritm: "",
      telefonopropie: "",
      nombrerespo: "",
      cedularespo: "",
      direccionrespo: "",
      telefonorespo: "",
      serialcarroceria: "",
      serialmotor: "",
      placa: "",
      marca: "",
      modelo: "",
      anio: "",
      color: "",
      uso: "",
      numpuesto: "",
      peso: "0,0",
      capacidadcarga: "0,0",
      servicio: "",
      tipovehiculo: "",
      valorvehiculo: "0,0",
      idclasevehiculo: "",
      fechainscripcion: fechaActual,
      status: "0",
    });
    setClasesVehiculo([]);
    setLoading(false);
    setLoadingBita(false);
    setLoadingDeclaWeb(false);
    setDeclaweb(false);
    setOperacion(4);
    setMontoAnual("");
    setCargadeuda({
      periodo: 0,
      periodopago: 0,
      periodohasta: 0,
    });
  };
  const cerrar = () => {
    blanquear();
    props.onHide();
  };
  useEffect(() => {
    if (values.idclasevehiculo && clasesVehiculo.length > 0 && factorCambio?.valor) {
      const precio = clasesVehiculo.find(
        (e) => e.idclasevehiculo === values.idclasevehiculo,
      );
      setMontoAnual(precio.monto);
      setMontoAnualBs(precio.monto * parseFloat(factorCambio?.valor))
    }
  }, [values.idclasevehiculo, clasesVehiculo, factorCambio?.valor]);
  return (
    <Modal
      {...props}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
      onShow={() => {
        setOperacion(props.operacion);
        buscarConfigValorVehiculo();
        buscarClasesVehiculos();
        buscarDeclaWeb();
        if (props && props.idVehiculo) {
          buscarVehiculoId(props.idVehiculo);
        }
      }}
    >
      <Modal.Header className="col-12 m-0 px-4 py-2 d-flex justify-content-between text-light rounded-top azulGradiant">
        <h3 className="fw-bold m-0">
          {operacion === 1
            ? "Agregar Vehiculos."
            : operacion === 2
              ? "Editar Vehiculos."
              : operacion === 3
                ? "Eliminar Vehiculos."
                : "Consultar Vehiculos."}
        </h3>
        <button onClick={() => cerrar()} className="btn btn-sm bg-light">
          <i className="fa fa-times"></i>
        </button>
      </Modal.Header>
      <Modal.Body>
        <ul className="nav " id="myTab" role="tablist">
          <li className="nav-item" role="presentation">
            <a
              className="rounded nav-link active bg-blue-100 text-light"
              id="datos-tab"
              data-bs-toggle="tab"
              data-bs-target="#datos"
              type="button"
              role="tab"
              aria-controls="datos"
              aria-selected="true"
            >
              Datos Generales
            </a>
          </li>
          <li className="nav-item" role="presentation">
            <a
              className=" rounded nav-link bg-blue-200 text-light"
              disabled={operacion === 1 || operacion === 3 ? true : false}
              id="deuda-tab"
              data-bs-toggle="tab"
              data-bs-target="#deuda"
              type="button"
              role="tab"
              aria-controls="deuda"
              aria-selected="false"
            >
              Deudas del Contribuyente
            </a>
          </li>
          <li className="nav-item" role="presentation">
            <a
              className=" rounded nav-link bg-blue-300 text-light"
              disabled={operacion === 1 || operacion === 3 ? true : false}
              id="multas-tab"
              data-bs-toggle="tab"
              data-bs-target="#multas"
              type="button"
              role="tab"
              aria-controls="multas"
              aria-selected="false"
            >
              Multas
            </a>
          </li>
          <li className="nav-item" role="presentation">
            <a
              className=" rounded nav-link bg-blue-400 text-light"
              disabled={operacion === 1 || operacion === 3 ? true : false}
              id="historico-tab"
              data-bs-toggle="tab"
              data-bs-target="#historico"
              type="button"
              role="tab"
              aria-controls="historico"
              aria-selected="false"
            >
              Historico de Pagos
            </a>
          </li>
        </ul>
        <div className="tab-content m-0 p-0" id="myTabContent">
          <div
            className="tab-pane fade show active col-12 m-0 mt-2 p-0"
            id="datos"
            role="tabpanel"
            aria-labelledby="datos-tab"
          >
            <div className="col-md-12 row mx-auto px-0">
              <div className="col-2 m-0 p-0">
                <Input
                  label="Código:"
                  disabled
                  name="idvehiculo"
                  value={values.idvehiculo}
                  id="inputCodigo"
                />
              </div>
              <div className="col-2 m-0 p-0 pl-2">
                <Input
                  label="Nº de RITM:"
                  name="ritm"
                  value={values.ritm.trim()}
                  id="inputRitm"
                  disabled
                />
              </div>
              <div className="col-2 m-0 p-0 pl-2">
                <Select
                  label="Estatus:"
                  disabled={operacion === 4 || operacion === 3 ? true : false}
                  className="form-control text-uppercase"
                  id="inputStatus"
                  name="status"
                  value={values.status}
                  onChange={(e) => {
                    const { name, value } = e.target;
                    onChange(name, value);
                  }}
                >
                  <option value="0">ACTIVO</option>
                  <option value="1">INACTIVO</option>
                </Select>
              </div>
              <div className="col-4 m-0 p-0 pl-2">
                <Input
                  type="date"
                  label="Fecha de Inscriccion:"
                  disabled={operacion === 4 || operacion === 3 ? true : false}
                  name="fechainscripcion"
                  max={fechaSistema}
                  value={moment
                    .utc(values.fechainscripcion)
                    .format("YYYY-MM-DD")}
                  id="inputFechaInscripcion"
                  onChange={(e) => {
                    const { name, value } = e.target;
                    onChange(name, value);
                  }}
                />
              </div>
              <div className="col-2 m-0 p-0 pl-2">
                Valor Euro €:
                {formatMoneda(
                  factorCambio?.valor.toString().replace(",", "").replace(".", ","),
                  ",",
                  ".",
                  2,
                )}
              </div>
              <fieldset className="col-6 m-0 p-2 d-flex flex-wrap border-azul rounded">
                <legend className="float-none w-auto m-0">
                  Datos del Propietario
                </legend>
                <div className="col-5 m-0 mb-2 p-0">
                  <Input
                    label="Cedula/RIF:"
                    disabled={operacion === 4 || operacion === 3 ? true : false}
                    maxLength="9"
                    name="cedulapropie"
                    value={values.cedulapropie}
                    id="inputCedula"
                    onChange={(e) => {
                      const { name, value } = e.target;
                      onChange(name, value);
                    }}
                  />
                </div>
                <div className="col-12 m-0 mb-2 p-0">
                  <Input
                    label="Apellidos y Nombres:"
                    disabled={operacion === 4 || operacion === 3 ? true : false}
                    name="nombrepropie"
                    value={values.nombrepropie}
                    id="inputPropiet"
                    onChange={(e) => {
                      const { name, value } = e.target;
                      onChange(name, value);
                    }}
                  />
                </div>
                <div className="col-12 m-0 mb-2 p-0">
                  <Textarea
                    label="Dirección:"
                    style={{ height: 70 }}
                    disabled={operacion === 4 || operacion === 3 ? true : false}
                    name="direccionpropie"
                    value={values.direccionpropie}
                    id="inputDirecpropiet"
                    onChange={(e) => {
                      const { name, value } = e.target;
                      onChange(name, value);
                    }}
                  />
                </div>
                <div className="col-6 m-0 p-0">
                  <Input
                    label="N° de Contacto:"
                    disabled={operacion === 4 || operacion === 3 ? true : false}
                    maxLength="12"
                    name="telefonopropie"
                    value={values.telefonopropie}
                    id="inputTelefonopropie"
                    onChange={handleInputNumChange}
                  />
                </div>
                <div className="col-4 m-0 p-0 pl-2">
                  <Checkbox
                    label="Responsable"
                    disabled={operacion === 4 || operacion === 3 ? true : false}
                    id="flexCheckIndeterminate"
                    onChange={(e) => {
                      const { checked } = e.target;
                      validarResponsable(checked);
                    }}
                  />
                </div>
              </fieldset>
              <div className="col-6 m-0 p-0 pl-2">
                <fieldset className="col-12 m-0 p-2 d-flex flex-wrap border-azul rounded">
                  <legend className="float-none w-auto m-0">
                    Datos del Responsable
                  </legend>
                  <div className="col-5 m-0 mb-2 p-0">
                    <Input
                      label="Cedula/RIF:"
                      disabled={
                        operacion === 4 || operacion === 3 ? true : false
                      }
                      maxLength="9"
                      name="cedularespo"
                      value={values.cedularespo}
                      id="inputCedrespon"
                      onChange={(e) => {
                        const { name, value } = e.target;
                        onChange(name, value);
                      }}
                    />
                  </div>
                  <div className="col-12 m-0 mb-2 p-0">
                    <Input
                      label="Apellidos y Nombres:"
                      disabled={
                        operacion === 4 || operacion === 3 ? true : false
                      }
                      name="nombrerespo"
                      value={values.nombrerespo}
                      id="inputNombrerespon"
                      onChange={(e) => {
                        const { name, value } = e.target;
                        onChange(name, value);
                      }}
                    />
                  </div>
                  <div className="col-12 m-0 mb-2 p-0">
                    <Textarea
                      label="Dirección:"
                      style={{ height: 70 }}
                      disabled={
                        operacion === 4 || operacion === 3 ? true : false
                      }
                      name="direccionrespo"
                      value={values.direccionrespo}
                      id="inputDireccionrespon"
                      onChange={(e) => {
                        const { name, value } = e.target;
                        onChange(name, value);
                      }}
                    />
                  </div>
                  <div className="col-6 m-0 p-0">
                    <Input
                      label="N° de Contacto:"
                      disabled={
                        operacion === 4 || operacion === 3 ? true : false
                      }
                      maxLength="11"
                      name="telefonorespo"
                      value={values.telefonorespo}
                      id="inputTelefrespon"
                      onChange={handleInputNumChange}
                    />
                  </div>
                </fieldset>
              </div>
            </div>
            <fieldset className="col-12 m-0 p-2 d-flex flex-wrap border-azul rounded">
              <legend className="float-none w-auto m-0">
                Datos del Vehículo
              </legend>
              <div className="col-4 m-0 mb-2 p-0">
                <Input
                  label="Serial de Carroceria:"
                  disabled={operacion === 4 || operacion === 3 ? true : false}
                  name="serialcarroceria"
                  value={values.serialcarroceria}
                  id="inputSerialcarro"
                  onChange={(e) => {
                    const { name, value } = e.target;
                    onChange(name, value);
                  }}
                />
              </div>
              <div className="col-2 m-0 mb-2 p-0 pl-2">
                <Input
                  label="Peso:"
                  disabled={operacion === 4 || operacion === 3 ? true : false}
                  name="peso"
                  value={values.peso}
                  id="inputPeso"
                  onChange={handleInputMontoChange}
                />
              </div>
              <div className="col-3 m-0 mb-2 p-0 pl-2">
                <Input
                  label="Cap. de Carga Tons:"
                  disabled={operacion === 4 || operacion === 3 ? true : false}
                  name="capacidadcarga"
                  value={values.capacidadcarga}
                  id="inputcapacidadcarga"
                  onChange={handleInputMontoChange}
                />
              </div>
              <div className="col-3 m-0 mb-2 p-0 pl-2">
                <Input
                  label="Servicio:"
                  disabled={operacion === 4 || operacion === 3 ? true : false}
                  name="servicio"
                  value={values.servicio}
                  id="inputservicio"
                  onChange={(e) => {
                    const { name, value } = e.target;
                    onChange(name, value);
                  }}
                />
              </div>
              <div className="col-3 m-0 mb-2 p-0">
                <Input
                  label="Serial del Motor:"
                  disabled={operacion === 4 || operacion === 3 ? true : false}
                  name="serialmotor"
                  value={values.serialmotor}
                  id="inputSerialmotor"
                  onChange={(e) => {
                    const { name, value } = e.target;
                    onChange(name, value);
                  }}
                />
              </div>
              <div className="col-2 m-0 mb-2 p-0 pl-2">
                <Input
                  label="Año:"
                  disabled={operacion === 4 || operacion === 3 ? true : false}
                  name="anio"
                  value={values.anio}
                  id="inputanio"
                  aria-label="Amount (to the nearest dollar)"
                  onChange={handleInputNumChange}
                />
              </div>
              <div className="col-2 m-0 mb-2 p-0 pl-2">
                <Input
                  label="Marca:"
                  disabled={operacion === 4 || operacion === 3 ? true : false}
                  name="marca"
                  value={values.marca}
                  id="inputMarca"
                  onChange={(e) => {
                    const { name, value } = e.target;
                    onChange(name, value);
                  }}
                />
              </div>
              <div className="col-3 m-0 mb-2 p-0 pl-2">
                <Input
                  label="Modelo:"
                  disabled={operacion === 4 || operacion === 3 ? true : false}
                  name="modelo"
                  value={values.modelo}
                  id="inputmodelo"
                  onChange={(e) => {
                    const { name, value } = e.target;
                    onChange(name, value);
                  }}
                />
              </div>
              <div className="col-2 m-0 mb-2 p-0 pl-2">
                <Input
                  label="Color:"
                  disabled={operacion === 4 || operacion === 3 ? true : false}
                  name="color"
                  value={values.color}
                  id="inputColor"
                  onChange={(e) => {
                    const { name, value } = e.target;
                    onChange(name, value);
                  }}
                />
              </div>
              <div className="col-3 m-0 p-0">
                <Input
                  label="Tipo de Vehículo:"
                  disabled={operacion === 4 || operacion === 3 ? true : false}
                  name="tipovehiculo"
                  value={values.tipovehiculo}
                  id="inputtipovehiculo"
                  onChange={(e) => {
                    const { name, value } = e.target;
                    onChange(name, value);
                  }}
                />
              </div>
              <div className="col-2 m-0 p-0 pl-2">
                <Input
                  label="N° Placa:"
                  disabled={operacion === 4 || operacion === 3 ? true : false}
                  name="placa"
                  value={values.placa}
                  id="inputplaca"
                  onChange={(e) => {
                    const { name, value } = e.target;
                    onChange(name, value);
                  }}
                />
              </div>
              <div className="col-2 m-0 p-0 pl-2">
                <Input
                  label="Puestos:"
                  disabled={operacion === 4 || operacion === 3 ? true : false}
                  maxLength="10"
                  name="numpuesto"
                  value={values.numpuesto}
                  id="inputnumpuesto"
                  onChange={handleInputNumChange}
                />
              </div>
              <div className="col-3 m-0 p-0 pl-2">
                <Input
                  label="Uso:"
                  disabled={operacion === 4 || operacion === 3 ? true : false}
                  name="uso"
                  value={values.uso}
                  id="inputuso"
                  onChange={(e) => {
                    const { name, value } = e.target;
                    onChange(name, value);
                  }}
                />
              </div>
              <div className="col-2 m-0 p-0 pl-2">
                <Input
                  label="Valor:"
                  disabled={operacion === 4 || operacion === 3 ? true : false}
                  value={values.valorvehiculo}
                  name="valorvehiculo"
                  id="inputvalorvehiculo"
                  onChange={handleInputMontoChange}
                />
              </div>
            </fieldset>
            <fieldset className="col-12 m-0 p-2 d-flex flex-wrap border-azul rounded">
              <legend className="float-none w-auto m-0">
                Datos Tributarios
              </legend>
              <div className="col-10 m-0 mb-2 p-0">
                <Select
                  label="Tipo Clasificación:"
                  name="idclasevehiculo"
                  disabled={operacion === 4 || operacion === 3 ? true : false}
                  value={values.idclasevehiculo}
                  id="inputFechaReg"
                  onChange={(e) => {
                    const { name, value } = e.target;
                    onChange(name, value);
                  }}
                >
                  <option value={""}>SELECCIONAR CLASE DEL VEHICULO</option>
                  {clasesVehiculo &&
                    clasesVehiculo.map((item, index) => (
                      <option key={index} value={item.idclasevehiculo}>
                        {" "}
                        {item.descripcion +
                          " - ( Valor: " +
                          formatMoneda(
                            item.monto
                              .toString()
                              .replace(",", "")
                              .replace(".", ","),
                            ",",
                            ".",
                            2,
                          ) +
                          ")"}{" "}
                      </option>
                    ))}
                </Select>
              </div>
              <div className="col-2 m-0 mb-2 p-0 pl-2">
                <Select
                  label="Año:"
                  value={anio}
                  onChange={(e) => {
                    const { value } = e.target;
                    setAnio(value);
                  }}
                  disabled={
                    operacion === 4 || operacion === 1 || operacion === 3
                      ? true
                      : false
                  }
                >
                  {anios &&
                    anios.map((e) => (
                      <option key={e} value={e}>
                        {e}
                      </option>
                    ))}
                </Select>
              </div>
              <div className="col-4 m-0 p-0">
                <Input
                  label="Monto Anual Bs:"
                  disabled
                  maxLength="10"
                  name="montoanual"
                  value={formatMoneda(
                    montoAnualBs.toString().replace(",", "").replace(".", ","),
                    ",",
                    ".",
                    2,
                  )}
                />
              </div>
              <div className="col-auto m-0 ml-auto p-0">
                <PrimaryButton
                  onClick={() => crearDeuda()}
                  icon="fa-spinner"
                  disabled={
                    operacion === 4 || operacion === 1 || operacion === 3
                      ? true
                      : false
                  }
                >
                  Cargar Deuda
                </PrimaryButton>
              </div>
            </fieldset>
          </div>
          <div
            className="tab-pane fade"
            id="deuda"
            role="tabpanel"
            aria-labelledby="deuda-tab"
          >
            <TablaDeudasVehiculos
              refreshDeuda={refreshDeuda}
              setRefreshDeuda={setRefreshDeuda}
              idVehiculo={props.idVehiculo}
            />
          </div>
          <div
            className="tab-pane fade"
            id="multas"
            role="tabpanel"
            aria-labelledby="multas-tab"
          >
            <TablaMultaVehiculos idVehiculo={props.idVehiculo} />
          </div>
          <div
            className="tab-pane fade"
            id="historico"
            role="tabpanel"
            aria-labelledby="historico-tab"
          >
            <TablaPagosVehiculos idVehiculo={props.idVehiculo} />
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <SuccessButton
          onClick={() => validarCamposVacios()}
          disabled={operacion === 4 ? true : false}
        >
          Aceptar
        </SuccessButton>
        <DangerButton onClick={() => cerrar()}>Cancelar</DangerButton>
      </Modal.Footer>

      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          if (mensaje.hideModal) cerrar();
          setMensaje({
            mostrar: false,
            titulo: "",
            texto: "",
            icono: "",
            hideModal: false,
          });
        }}
      />

      <Dimmer active={loading || loadingBita || loadingDeclaWeb} inverted />
    </Modal>
  );
};
